import { useHomeText } from '../text';

const SoonToast = () => {
  const t = useHomeText();
  return (
    <div id="kh-soon" hidden>
      <div role="status" aria-live="polite" style={{ position: "fixed", top: "84px", left: "50%", transform: "translateX(-50%)", zIndex: "60", display: "flex", alignItems: "center", gap: "12px", padding: "12px 20px 12px 14px", borderRadius: "18px", background: "#FFFFFF", color: "#0B1240", boxShadow: "0 18px 40px rgba(11,18,64,0.3)", border: "2px solid #FFC93C" }}>
        <span style={{ width: "36px", height: "36px", borderRadius: "12px", background: "#FFC93C", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0B1240" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </span>
        <span style={{ display: "flex", flexDirection: "column", lineHeight: "1.3" }}>
          <strong style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif", fontSize: "20px" }}>
            {t.toast.comingSoon}
          </strong>
          <span id="kh-soon-msg" style={{ fontSize: "13px", color: "#4B5480" }}>
            {t.toast.theParentSpaceIs}
          </span>
        </span>
      </div>
    </div>
  );
};

export default SoonToast;
